// React Imports
import React, { Component } from "react";
import {Col, Image} from "react-bootstrap";

import img from "../assets/img/Self-Portrait.jpg";

export default class AboutDetail extends Component {
    render() {
        return <div className="container">
            <Col md={4} sm={12}>
                <Image src={img} responsive/>
            </Col>
            <Col md={8} sm={12}>
                <div className="about-name">
                    Barbara Van Baush
                </div>
                <div className="about-text">
                    Barbara Van Baush has been drawing for years and is excited to be fully focused on her art again.
                </div>

                <div className="about-text">
                    Drawing has been the way she commemorates and remembers her loved ones and
                    she would love to help you do the same.
                </div>

                <div className="about-text">
                    Please email her with any questions you have at
                    <a href={"mailto:portraitswithpastels@gmail.com"}> portraitswithpastels@gmail.com</a>.
                </div>


            </Col>
        </div>;
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/AboutDetail.js
 **/